import { SafePromise } from '@benzinga/safe-await';

import { IncludeHeader, RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { NodeId, RestfulStory } from '../entities';
import { AdvancedNewsEnvironment } from '../environment';

export class AdvancedNewsContentRestful extends RestfulClient {
  constructor(session: Session, includeHeaders?: IncludeHeader) {
    super(session.getEnvironment(AdvancedNewsEnvironment).contentUrl, session, includeHeaders);
  }

  public getStory = (nodeid: NodeId): SafePromise<RestfulStory> => {
    const url = this.URL(`nid/${nodeid}`, {
      apikey: this.session.getEnvironment(AdvancedNewsEnvironment).contentKey,
    });
    return this.get(url, { allowsAnonymousAuth: true, mode: 'no-cors' });
  };
}
